var ContractEdtiModal = (function (base) {
  __extends(ContractEdtiModal, base);


  function ContractEdtiModal(apiClient) {
    const self = base.call(this, apiClient) || this;
    return self;
  };


  ContractEdtiModal.prototype.activate = function (contractId) {
    const self = this;
    const isNew = !contractId;
    const url = contractId ? 'api/contracts/{0}/edit'.format(contractId) : 'api/contracts/add';

    this.loadContent(url)
      .then($modal => {

        var $form = $('form', $modal);
        FormHelper.init($form, isNew ? 'PUT' : 'POST', 'api/contracts');
        FilesUploader.initUploadingOnSubmit(VideoServerSettings.url, $form, 'UploadedFile', () => false, fileType => fileType === 1 || fileType === 4);

        $(".select2", $modal).select2({
          placeholder: 'Введите участки обслуживания'
        });

        $('.date', $modal).datepicker({
          language: 'ru',
          format: 'yyyy-mm-dd',
          todayHighlight: true,
          toggleActive: true,
          autoclose: true
        });

        $('#supplementaryAgreementsTable', $modal).DataTable({
          language: {
            url: Url.content("Content/Inspinia/plugins/dataTables/languages/Russian.json")
          },
          processing: true,
          searching: false,
          columnDefs: [
            {
              orderable: false,
              visible: true,
              targets: 0
            },
            {
              orderable: false,
              targets: 1,
              visible: true
            }
          ],
          order: false,
          paging: false
        });

        $modal

          //Кнопка 'Сохранить'
          .on('click', '[js=save]', function () {
            $modal.busy();
            $form.send()
              .then(() => self.close({ ok: true }))
              .catch(() => $modal.busy(false));
          })

          // Добавление доп соглашения
          .on('click', '#add-agreement', function () {
            var control = $(this);
            var table = $('#supplementaryAgreementsTable', $modal).DataTable();

            $('#supplementaryAgreementsTable_processing', $modal).attr('style', 'display: block;');
            var url = contractId ? 'api/contracts/{0}/edit/AddSupplementaryAgreement'.format(contractId) : 'api/contracts/add/AddSupplementaryAgreement';
            self.apiClient.post(url, {
              SaNumber: $('#SaNumber', $modal).val(),
              SaDate: $('#SaDate', $modal).val()
            })
            .then(result => {
              $('#supplementaryAgreementsTable_processing', $modal).attr('style', 'display: none;');
              if (result.result) {
                $('#SaNumber', $modal).siblings('span').text('');
                $('#SaDate', $modal).siblings('span').text('');

                var date = (new Date(Number(result.result.Date.replace('/Date(', '').replace(')/', ''))))
                  .toLocaleDateString("ru-RU");
                var char = result.result.Number;
                var select = $(table.row('#create-tr').node()).children('td');

                table.row('#create-tr').remove().draw(false);
                var tr2 = '<div class="input-group"> <label class="control-label">' +
                  date +
                  '</label><span class="input-group-btn"><button type="button" class="btn no-borders text-black del-agreement" data-id="0" data-sa="' +
                  char +
                  date +
                  '"><i class="fa fa-minus"></i></button></span></div>';
                table.row.add([
                    '<label class="control-label">' + char + '</label>',
                    tr2
                ])
                  .draw(false);

                table.row.add([select[0].innerHTML, select[1].innerHTML]).draw(false);
                table.rows()
                  .every(function (rowIdx, tableLoop, rowLoop) {
                    if (table.rows()[0].length - 1 === rowIdx) {
                      $(this.node()).attr('id', 'create-tr');
                    } else {
                      $(this.node()).attr('id', 'row_' + rowIdx);
                    }
                    $(this.node()).children('td').addClass('text-center');
                  });
                table.draw();
              } else {
                if (result.error.saNumber) {
                  $('#SaNumber', $modal).siblings('span').text(result.error.saNumber);
                } else {
                  $('#SaNumber', $modal).siblings('span').text('');
                }

                if (result.error.saDate) {
                  $('#SaDate', $modal).siblings('span').text(result.error.saDate);
                } else {
                  $('#SaDate', $modal).siblings('span').text('');
                }
              }

              $('.date')
                .datepicker({
                  language: 'ru',
                  format: 'yyyy-mm-dd',
                  todayHighlight: true,
                  toggleActive: true,
                  autoclose: true
                });
            });
          })

          // Удаление доп соглашения
          .on('click', '.del-agreement', function () {
            var control = $(this);
            var table = $('#supplementaryAgreementsTable', $modal).DataTable();
            var url = contractId ? 'api/contracts/{0}/edit/DeleteSupplementaryAgreement'.format(contractId) : 'api/contracts/add/DeleteSupplementaryAgreement';
            self.apiClient.post(url, {
                id: $(this).data('id'),
                saVal: $(this).data('sa')
            })
            .then(function (result) {
              if (result.result) {
                $('#supplementaryAgreementsTable_processing').attr('style', 'display: none;');
                table.row('#' + control.closest('tr').attr('id')).remove().draw(false);
              }
            });
          });
      });
  };


  return ContractEdtiModal;
}(BaseModal));
